export const ACCESS_TOKEN_KEY = 'abcconst-admin-access-token';
export const USER_ROLE_KEY = 'abcconst-admin-user-role';

let accessToken: string | null = null;
let userRole: string | null = null;

const readFromStorage = (key: string) => {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getAccessToken = () => accessToken ?? readFromStorage(ACCESS_TOKEN_KEY);
export const getUserRole = () => userRole ?? readFromStorage(USER_ROLE_KEY);
export const isAuthenticated = () => Boolean(getAccessToken());

export const setAccessToken = (token: string | null) => {
  accessToken = token;
  if (typeof window === 'undefined') return;

  try {
    if (token) {
      sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    }
  } catch {
    // ignore storage failures in private or restricted contexts
  }
};

export const setUserRole = (role: string | null) => {
  userRole = role;
  if (typeof window === 'undefined') return;

  try {
    if (role) {
      sessionStorage.setItem(USER_ROLE_KEY, role);
    } else {
      sessionStorage.removeItem(USER_ROLE_KEY);
    }
  } catch {
    // ignore storage failures in private or restricted contexts
  }
};

export const clearAuth = () => {
  accessToken = null;
  userRole = null;
  if (typeof window === 'undefined') return;

  try {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(USER_ROLE_KEY);
  } catch {
    // ignore storage failures in private or restricted contexts
  }
};
